var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChevlefttiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-chev left tiny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-chev-left-tiny",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    transform: "translate(10.000000, 10.000000) scale(-1, -1) rotate(90.000000) translate(-10.000000, -10.000000) ",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2207063,7.50492289 C14.2275178,7.51154898 14.2342375,7.5182687 14.2408636,7.52508013 C14.6532482,7.94900005 14.6532482,8.62415944 14.2408636,9.04807935 L10.9073602,12.4748276 C10.6629504,12.726074 10.3218799,12.8264302 10.0002916,12.7742943 C9.67882637,12.8266378 9.33730261,12.7263341 9.09263983,12.4748276 L9.09263983,12.4748276 L5.75913644,9.04807935 C5.34675176,8.62415944 5.34675176,7.94900005 5.75913644,7.52508013 L5.75913644,7.52508013 L5.77929367,7.50492289 C6.18841436,7.10693474 6.84270535,7.11595945 7.2406935,7.52508013 L7.2406935,7.52508013 L9.99984793,10.3602368 L12.7593065,7.52508013 C13.1572947,7.11595945 13.8115856,7.10693474 14.2207063,7.50492289 Z",
    id: "Combined-Shape",
    fill: "#333333",
    transform: "translate(10.000000, 10.000000) rotate(-270.000000) translate(-10.000000, -10.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevlefttiny);
export default __webpack_public_path__ + "static/media/ic-chev left tiny.8a4d3ef1.svg";
export { ForwardRef as ReactComponent };